import { notifications } from '../../engine/modules/ui/notifications.js';

function notify(content, options = {}) {
  const notification = typeof content === 'string'
    ? Object.assign({}, options, { content })
    : Object.assign({}, content);

  notifications.add(notification);
}

function notifySuccess(content, options = {}) {
  notify(content, Object.assign({ variant: 'success' }, options));
}

function notifyError(content, options = {}) {
  notify(content, Object.assign({ variant: 'error' }, options));
}

function notifyInfo(content, options = {}) {
  notify(content, Object.assign({ variant: 'info' }, options));
}

function notifyWarning(content, options = {}) {
  notify(content, Object.assign({ variant: 'warning' }, options));
}

export { notify, notifySuccess, notifyError, notifyInfo, notifyWarning };
